const CLOUDINARY_IMAGE_ZOOM_PARAMS = ['c_fill', 'g_auto', 'f_auto', 'w_iw']
export const CLOUDINARY_ZOOM_URL = `https://res.cloudinary.com/appbuilder/image/fetch/${CLOUDINARY_IMAGE_ZOOM_PARAMS.join(
  ','
)}/`
